export{WishlistProvider}from"./provider.js";export{useWishlistId}from"./hooks/use-wishlist-id.js";
//# sourceMappingURL=index.js.map
